import React from 'react'
import ViewMode from 'components/Patients/Chat/ViewMode'

const DisabledPatientBanner = () => {
  return <ViewMode isBanner={true} />
}

export default DisabledPatientBanner
